export const ACCESS_TOKEN = 'ACCESS_TOKEN';
export const SUPERADMIN_ACCESS_TOKEN = 'SUPERADMIN_ACCESS_TOKEN';
export const REFRESH_TOKEN = 'REFRESH_TOKEN';
export const EXPIRY_AT = 'EXPIRY_AT';
